import Axios from 'axios'
import Cookies from 'js-cookie';
import {
  API_ROOT
} from '../../config'

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000

});
console.log(API_ROOT);

export default {
  state: {
    access: false,
    user: {},
    login_obj:{}
  },
  mutations: {
    LOGIN(state, login_obj) {
      console.log('Login');

      Cookies.set('user', JSON.stringify(login_obj.data));
      Cookies.set('access', 1);
      state.access = Cookies.get('access');
      state.user = Cookies.getJSON('user');
      state.login_obj = login_obj;
    },
    LOGOUT(state) {
      console.log('Logout');
      Cookies.remove('user');
      Cookies.remove('access');
      state.access = 0;
      state.user = null;
    }
  },
  getters: {
    getLoggedin(state) {
      return state.login_obj;
    },
    getUser(state) {
      return state.user;
    }
  },
  actions: {
    logout(context) {
      context.commit('LOGOUT')
    },
    login(context, obj) {
      console.log(context);

      instance.post('/login/', {
        username: obj.username,
        password: obj.password
      }).then(function (response) {
        console.log(response);
        var obj = response.data;

        context.commit('LOGIN', obj);

      }).catch(function (error) {
        console.log(error);
      });
    }
  }
}
